import { render, staticRenderFns } from "./home.vue?vue&type=template&id=76d2aaf1"
import script from "./home.vue?vue&type=script&lang=ts"
export * from "./home.vue?vue&type=script&lang=ts"
import style0 from "./home.vue?vue&type=style&index=0&id=76d2aaf1&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76d2aaf1')) {
      api.createRecord('76d2aaf1', component.options)
    } else {
      api.reload('76d2aaf1', component.options)
    }
    module.hot.accept("./home.vue?vue&type=template&id=76d2aaf1", function () {
      api.rerender('76d2aaf1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "home/home.vue"
export default component.exports